import * as React from 'react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import { Modal, Button, ButtonGroup } from 'react-bootstrap'
import Form, { AjvError, IChangeEvent } from 'react-jsonschema-form'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import {
    QuestionnaireStatus,
    getQuestionnaireStatusText,
    getQuestionnaireStatusClass,
    getQuestionnaireStatusTextForList,
} from '../../../Model/Questionnaire'
import EnumHelpers from '../../../Helpers/EnumHelpers'
import { observable } from 'mobx'
import { CancelReason } from '../../../Model/CancelReasonModel'
import {
    getQuestionnaireStatusSchema,
    UICancelQuestionnaireStatusSchema,
    UIQuestionnaireStatusSchema
} from '../../../Model/QStatusChangeFormModel'

export interface IQuestionnaireStatusViewProps {
    status: QuestionnaireStatus,
    qId: string,
    inProgressByUserId: string,
    cancelReason?: CancelReason
    className?: string,
    localizationStore?: LocalizationStore,
    httpActionsService?: HttpActionsService
    userStore?: UserStore
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = LocalizationStore.getInstance().t('is a required property')
        }
        return error
    })
}

@inject('userStore')
@inject('localizationStore')
@inject('httpActionsService')
@observer
export default class QuestionnaireStatusView
    extends React.Component<IQuestionnaireStatusViewProps> {

    @observable
    isShowModal: boolean = false

    // uiSchema: any = UICommentFormSchema
    formData = {
        qId: '',
        status: 0,
        comment: ''
    }
    // constructor(props: IQuestionnaireStatusViewProps) {
    //     super(props)
    //     this.state = {
    //         showModal: false,
    //         // status: undefined
    //     }
    // }

    getStatusList(status: QuestionnaireStatus) {
        const { userStore, inProgressByUserId } = this.props
        if (userStore!.checkSuperAdmin) {
            return EnumHelpers.values(QuestionnaireStatus)
                .map(Number)
                .filter(x =>
                    ![QuestionnaireStatus.InProgressCreditConsultant, QuestionnaireStatus.InProgressCreditExpert]
                        .includes(x)
                )
        }

        switch (status) {
            case QuestionnaireStatus.Draft:
                if (userStore!.checkCreditConsultant) {
                    return [QuestionnaireStatus.InProgressCreditConsultant]
                } else if ((userStore!.checkCreditExpert) ||
                    (userStore!.checkCreditGroupAdministrator) ||
                    (userStore!.checkAdmin)) {
                    return [QuestionnaireStatus.Canceled]
                }
                return []

            case QuestionnaireStatus.InProgressCreditConsultant:
                if (userStore!.checkCreditConsultant && userStore!.id === inProgressByUserId) {
                    return [
                        QuestionnaireStatus.Draft,
                        QuestionnaireStatus.AcceptedCreditConsultant,
                        QuestionnaireStatus.Canceled
                    ]
                } else if (
                    userStore!.checkCreditConsultant ||
                    userStore!.checkCreditExpert ||
                    userStore!.checkCreditGroupAdministrator ||
                    userStore!.checkAdmin) {
                    return [QuestionnaireStatus.Canceled]
                }
                return []

            case QuestionnaireStatus.AcceptedCreditConsultant:
                if ((userStore!.checkCreditConsultant) ||
                    (userStore!.checkCreditExpert) ||
                    (userStore!.checkCreditGroupAdministrator) ||
                    (userStore!.checkAdmin)) {
                    return [QuestionnaireStatus.Canceled]
                }
                return []

            case QuestionnaireStatus.AcceptedCreditExpert:
                if (userStore!.checkLogisticsAgent) {
                    return [QuestionnaireStatus.Delivery]
                } else if ((userStore!.checkCreditConsultant) ||
                    (userStore!.checkCreditExpert) ||
                    (userStore!.checkCreditGroupAdministrator) ||
                    (userStore!.checkAdmin)) {
                    return [QuestionnaireStatus.Canceled]
                }
                return []

            case QuestionnaireStatus.Scored:
                if (userStore!.checkCreditExpert) {
                    return [QuestionnaireStatus.InProgressCreditExpert]
                } else if ((userStore!.checkCreditConsultant) ||
                    (userStore!.checkCreditGroupAdministrator) ||
                    (userStore!.checkAdmin)) {
                    return [QuestionnaireStatus.Canceled]
                }
                return []

            case QuestionnaireStatus.InProgressCreditExpert:
                if (userStore!.checkCreditExpert && userStore!.id === inProgressByUserId) {
                    return [
                        QuestionnaireStatus.Scored,
                        QuestionnaireStatus.AcceptedCreditExpert,
                        QuestionnaireStatus.Canceled
                    ]
                } else if (
                    userStore!.checkCreditExpert ||
                    userStore!.checkCreditConsultant ||
                    userStore!.checkCreditGroupAdministrator ||
                    userStore!.checkAdmin) {
                    return [QuestionnaireStatus.Canceled]
                }
                return []
            case QuestionnaireStatus.Delivery:
                if (userStore!.checkLogisticsAgent) {
                    return [
                        QuestionnaireStatus.ActiveCredit,
                        QuestionnaireStatus.Canceled
                    ]
                }
                return []

            case QuestionnaireStatus.ActiveCredit:
                if (userStore!.checkLawyer) {
                    return [QuestionnaireStatus.PreTrialCase]
                }
                return []
            case QuestionnaireStatus.PreTrialCase:
                if (userStore!.checkLawyer) {
                    return [QuestionnaireStatus.LawCourt]
                }
                return []
            case QuestionnaireStatus.LawCourt:
                if (userStore!.checkLawyer) {
                    return [QuestionnaireStatus.CourtsDecision]
                }
                return []
            case QuestionnaireStatus.Canceled:
                return []
            case QuestionnaireStatus.Hold:
                return [QuestionnaireStatus.ActiveCredit]
            default: return []
        }
    }

    showModal(e: React.MouseEvent<any>, status: QuestionnaireStatus) {
        this.formData = {
            qId: this.props.qId,
            status: status,
            comment:
                `${this.props.localizationStore!.t!('new')} ${this.props.localizationStore!.t!('status')}: ` +
                getQuestionnaireStatusText(status)
        }

        this.isShowModal = true
        // this.setState({
        //     showModal: true,
        //     // status: status
        // })
    }

    handleClose() {
        this.isShowModal = false
        // this.setState({
        //     showModal: false,
        //     // status: undefined
        // })
    }

    handleOk(e: IChangeEvent<any>, context: QuestionnaireStatusView) {
        this.props.httpActionsService!
            .changeStatus(e.formData['qId'], e.formData['status'], e.formData['comment'], e.formData['cancelReason'])

        // context.setState({ showModal: false })
        this.isShowModal = false
    }

    render() {

        const statuses = this.getStatusList(this.props.status)
        const { className, status, localizationStore, cancelReason } = this.props

        return (
            <div className={className}>
                <div className="text-center">
                    <p>
                        {localizationStore!.t!('currentStatus')}:&nbsp;
                        {getQuestionnaireStatusTextForList(status)}
                    </p>

                    {
                        status === QuestionnaireStatus.Canceled && cancelReason ?
                            <p>
                                {localizationStore!.t('cancelReason')}:&nbsp;
                                {localizationStore!.t(CancelReason[cancelReason])}
                            </p>
                            :
                            ''
                    }
                </div>

                {
                    statuses && statuses.length ?
                        <ButtonGroup>
                            {statuses
                                .map(x =>
                                    <Button
                                        key={x}
                                        onClick={(e) => this.showModal(e, x)}
                                        className={getQuestionnaireStatusClass(x)}
                                    >
                                        {getQuestionnaireStatusText(x)}
                                    </Button>)}
                        </ButtonGroup>
                        : null
                }

                <Modal
                    show={this.isShowModal}
                    onHide={() => { return }}
                    animation={false}
                    keyboard={false}
                    backdrop={true}
                >
                    <h6>{localizationStore!.t!('ChangeStatusConfirm')}</h6>
                    <div className="formWrapper col-12">
                        <Form
                            onSubmit={(e) => { this.handleOk(e, this) }}
                            schema={getQuestionnaireStatusSchema(this.formData.status)}
                            uiSchema={
                                this.formData.status === QuestionnaireStatus.Canceled ?
                                    UICancelQuestionnaireStatusSchema : UIQuestionnaireStatusSchema}
                            formData={this.formData}
                        >
                            <Button
                                bsStyle="link"
                                className="col-6"
                                onClick={(e) => { return this.handleClose() }}
                            >
                                {localizationStore!.t!('Cancel')}
                            </Button>
                            <Button
                                type="submit"
                                bsStyle="success"
                                className="col-6"
                            >
                                {localizationStore!.t!('Ok')}
                            </Button>
                        </Form>
                    </div>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireStatusView.tsx